import { Path } from '@/types/global';
import { OneOffCheckRecord } from '@/types/turn-api';
import { OneOffCheckActionEnum } from '@/types/turn-enums';
import { FormFields } from './types';

export const REQUIRES_PROOF: OneOffCheckRecord.Action[] = [
  OneOffCheckActionEnum.Clear,
  OneOffCheckActionEnum.Consider,
  OneOffCheckActionEnum.Fulfilled,
  OneOffCheckActionEnum.ToFulfilled,
];

export const path = (path: Path<FormFields>) => path;
